import React from 'react';
import Box from '../../styled/Box';
import {Paragraph} from '../../styled/Typography';
import {Button, TrovaButton} from '../../styled/Button';

const FooterNav = React.memo(() => {
  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      flexDirection={['column-reverse', 'column-reverse', 'row']}
      bg={'#f3f6f8'}
      p={['40px 20px', '40px 20px', '80px 20px']}
      color={'#4f5388'}
    >
      <Box display={'flex'} alignItems={'center'}>
        <Paragraph mb={0}>
          &#169; Trova {new Date().getFullYear()}
        </Paragraph>
      </Box>
      <Box
        display={'flex'}
        alignItems={'center'}
        flexDirection={['column', 'column', 'row']}
      >
        <Button href={'/how-it-works'} variant={'link'} color={'#4f5388'}>
          How it works
        </Button>
        <Button href={'/#faqs'} variant={'link'} color={'#4f5388'}>
          FAQs
        </Button>
        <Button href='/about-us' variant='link' color={'#4f5388'}>
          About
        </Button>
        <Button href='/careers' variant='link' color={'#4f5388'}>
          Careers
        </Button>
        <Button href='mailto:info@gotrova.ai' target={'_blank'} variant='link' color={'#4f5388'}>
          Contact Us
        </Button>
        <Button href='/tos' variant='link' color={'#4f5388'}>
          Terms of Use
        </Button>
        <Button href='/privacy' variant='link' color={'#4f5388'}>
          Privacy Policy
        </Button>
        <TrovaButton href='/signin-beta' width={130} height={45} ml={[0, 0, 3]}>
          Try free
        </TrovaButton>
      </Box>
    </Box>
  )
})

export default FooterNav;